import React from 'react';
// import TeacherMasterLayout from '../../../layouts/gcstaff/staffMasterLayout/TeacherMasterLayout';
import MyNotesPage from '../../../subsreens/gcstaff/staffnotespage/MyNotesPage';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';


const StaffMyNotes = () => {
    return(
       <TeacherMasterLayout>
        <MyNotesPage/>
       </TeacherMasterLayout>
    )
}

export default StaffMyNotes;